/**
 * Uplive客户端分享
 */
import pack from './pack';

const shareChannels = ["qq", "qzone", "wechat_friends", "wechat_circle", "sina", "fb", "tw", "messenger", "whatsapp", "ins", "line", "kakao"];

const style = {
	layer: {
		position: "fixed",
        maxHeight: "100%",
        maxWidth: "100%",
        overflow: "hidden",
        height: "100%",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        margin: "auto",
        zIndex: 998,
        WebkitBackfaceVisibility: "hidden",
        display: "block"
	},
	mask: {
		backgroundColor: "rgb(0, 0, 0)",
    	opacity: 0.5
	},
	content: {
		position: "fixed",
        left: 0,
        bottom: 0,
        right: 0,
        margin: "auto",
        overflow: "hidden",
        zIndex: 999,
        backgroundColor: "rgb(255, 255, 255)",
        borderRadius: '0.25rem 0.25rem 0 0',
        '-webkit-transform': "translateY(100%)"
	},
	enterstyle: {
        opacity: 1,
        '-webkit-transform': "translateY(0) translateZ(0)",
        '-webkit-transition': "-webkit-transform 0.3s cubic-bezier(.17,.67,.34,1), opacity .3s cubic-bezier(.17,.67,.34,1)"
    },
	leavestyle: {
        opacity: 1,
        '-webkit-transform': "translateY(100%)"
    },

}

class Share {
    constructor(cfg) {
    	cfg =  cfg || {};
        this.channels = cfg.channels || shareChannels;
        this.shareData = this.parseShareData(cfg.shareData);
        this.complete = cfg.complete || function(){};
    }

    parseShareData(cfg){
        let shareData = {};
        let { url, title, imageUrl, desc, platform } = cfg;
        
        shareChannels.forEach(function(item, i) {
            if (platform[item]) {
                shareData[item] = Object.assign({
                    url: url,
                    title: title,
                    imageUrl: imageUrl,
                    desc: desc
                }, platform[item]);
            } else {
                shareData[item] = {
                    url: url,
                    title: title,
                    imageUrl: imageUrl,
                    desc: desc
                };
            }
        });
        
        return shareData;
    }

    buildDOM() {
    	let $node = this.$node = $('<div class="upsdk-share"></div>');
    	let $mask = this.$mask = $('<div></div>');
    	let $content = this.$content = $('<div></div>');
    
    	let html = [
    		'<div class="upsdk-share-box">',
    			// '<div class="upsdk-share-box-hd">' + Uplib.tpl('分享')+ '</div>',
    			'<div class="upsdk-share-box-bd">' + this.renderOption() + '</div>',
    			'<div class="upsdk-share-box-ft" node-id="close">' + Uplib.tpl('取消')+ '</div>',
    		'</div>'
    	].join('');

    	let $box = $(html);

    	$content.append($box);
    	$content.css(style.content);

    	$node.append($content);

    	$mask.css(Object.assign({}, style.layer, style.mask));
    	$node.append($mask);
    	
    	$(document.body).append($node);
    	
    	$content.css({
    		width : $box.offset().width + "px",
            height: $box.offset().height + "px"
    	});
    }

    renderOption () {
        let arr = [];

        $.each(this.channels, (index, value) =>{
            let node = '<li data-channel="' + value +'" node-id="channel-option"><label>' + Uplib.tpl(value) +'</label></li>';

            arr[arr.length] = node;
        });

        return '<ul>' + arr.join('') + '</ul>';
    }

    bindEvent() {
    	let el = this.$node;
    	
    	el.on('click', '[node-id="channel-option"]', (e)=>{
    		this.handleShare(e);
    	})
    	.on('click', '[node-id="close"]', (e)=>{
    		this.hide();
    	})

    	this.$mask.on('click', (e)=>{
    		this.hide();
    	})
    }

    handleShare(e) {
    	let target = $(e.currentTarget);
    	let type = target.attr('data-channel');

    	Uplib.native.singleShare(Object.assign({}, this.shareData[type], {
    		type,
            complete: this.complete,
    		errtip: ()=>{}
    	}));
    }

    showAnim(callback) {
        let self = this;
        let el = this.$content[0];

        function endFun() {
            if (typeof callback == 'function') {
                callback();
            }
            el.removeEventListener("webkitTransitionEnd", endFun)
        }
        el.addEventListener("webkitTransitionEnd", endFun, false);

        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.$content.css(style.enterstyle);
        }, 100);
    }

    hideAnim(callback) {
        let self = this;
        let el = this.$content[0];

        function endFun() {
            if (typeof callback == 'function') {
                callback();
            }
	        el.style.display = 'none';
            el.removeEventListener("webkitTransitionEnd", endFun)
        }

        el.addEventListener("webkitTransitionEnd", endFun, false);

       	$(el).css(style.leavestyle);
    }


    show() {
    	if(!this.$node) {
    		this.buildDOM();
        	this.bindEvent();
    	}

    	this.showAnim();
    }

    hide() {
    	this.hideAnim(()=>{
    		this.$node.remove();
    	});
    }
}

export default Share;


// WEBPACK FOOTER //
// ./src/js/openjs/deps/share-client/index.js